import { nanoid } from "nanoid";
import { uploadApi } from "@/shared/lib/upload-api";
import { uploadFileToPresignedUrl } from "@/shared/lib/upload-to-presigned";

function sanitizeFilename(name: string): string {
  return name.replace(/[^a-zA-Z0-9._-]/g, "_").slice(0, 100) || "file";
}

/**
 * ອັບໂຫຼດສະລິບໄປ object store (ເອີ້ນຕອນກົດບັນທຶກການຊຳລະ — ບໍ່ໃຊ້ຕອນເລືອກໄຟລ໌ຢ່າງດຽວ).
 */
export async function uploadPaymentSlipFile(
  file: File,
  documentId: string,
): Promise<{ fileKey: string; fileName: string }> {
  const ext = file.name.includes(".") ? (file.name.split(".").pop() ?? "") : "";
  const baseName = file.name.includes(".")
    ? file.name.slice(0, file.name.lastIndexOf("."))
    : file.name;
  const safeBase = sanitizeFilename(baseName);
  const key = `uploads/quotation-invoice/${documentId}/${Date.now()}-${nanoid().slice(0, 8)}-${safeBase}${ext ? `.${ext}` : ""}`;
  const contentType = file.type || undefined;
  const { uploadUrl } = await uploadApi.getPresignUrl({ key, contentType });
  await uploadFileToPresignedUrl(uploadUrl, file, { contentType });
  return { fileKey: key, fileName: file.name };
}
